import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import logo from '../assets/default-if-logo.png';
import { SEAT_PRICE_LABEL, PREMIUM_INCLUDED_SEATS } from '../utils/seatPricing';
import '../styles/Plans.css';

const PRICING = {
  standard: { monthly: 75, annual: 810 },
  premium: { monthly: 125, annual: 1350 },
};

function getFeatures(seatPrice) {
  return [
    ['Proposals, Invoicing and Purchase Orders', true, true],
    ['Standard Reports', true, true],
    ['Time Billing', true, true],
    ['Planner', true, true],
    ['Customizable Reports', false, true],
    [`${PREMIUM_INCLUDED_SEATS} Additional Free Users`, false, true],
    [`Additional Users at ${seatPrice} Each`, true, true],
    ['QuickBooks Integration', false, true],
  ];
}

export default function PublicPricing() {
  const navigate = useNavigate();
  const [billing, setBilling] = useState('monthly');
  const seatPrice = SEAT_PRICE_LABEL[billing];

  return (
    <div className="plans-scroll">
      <div className="plans-page">
        <div className="plans-logo-row">
          <img
            src={logo}
            alt="InteriorFolio"
            className="plans-logo"
            style={{ cursor: 'pointer' }}
            onClick={() => navigate('/')}
          />
        </div>

        <header className="plans-header">
          <h1 className="plans-title">Simple, Transparent Pricing</h1>
          <p style={{ color: '#6b7280', marginTop: 8, fontSize: 16 }}>
            Choose the plan that fits your design firm.
          </p>
        </header>

        <section className="plans-billing-toggle">
          <button
            className={billing === 'monthly' ? 'active' : ''}
            onClick={() => setBilling('monthly')}
          >
            Monthly
          </button>
          <button
            className={billing === 'annual' ? 'active' : ''}
            onClick={() => setBilling('annual')}
          >
            Annual (Save 10%)
          </button>
        </section>

        <section className="plans-cards">
          {/* Standard */}
          <div className="plan-card">
            <h2>Standard</h2>

            <div className="price">
              {billing === 'monthly' ? (
                <span className="monthly">${PRICING.standard.monthly}/mo</span>
              ) : (
                <span className="annual">${PRICING.standard.annual}/yr</span>
              )}
            </div>

            {billing === 'annual' && (
              <p className="save">Save 10% with an annual subscription!</p>
            )}

            <p className="per-user">Per User*</p>

            <p className="description">
              Essential features for efficient project management and creativity in your design firm.
            </p>

            <button
              type="button"
              className="choose-btn"
              onClick={() => navigate(`/signup?plan=standard&billing=${billing}`)}
            >
              Get Started
            </button>
          </div>

          {/* Premium */}
          <div className="plan-card premium">
            <span className="badge">User&apos;s Favorite</span>

            <h2>Premium</h2>

            <div className="price">
              {billing === 'monthly' ? (
                <span className="monthly">${PRICING.premium.monthly}/mo</span>
              ) : (
                <span className="annual">${PRICING.premium.annual}/yr</span>
              )}
            </div>

            {billing === 'annual' && (
              <p className="save">Save 10% with an annual subscription!</p>
            )}

            <p className="per-user">Per User + {PREMIUM_INCLUDED_SEATS} Additional Users*</p>

            <p className="description">
              Exclusive features including customizable reporting, QuickBooks Online integration,
              and {PREMIUM_INCLUDED_SEATS} free additional users for collaboration.
            </p>

            <button
              type="button"
              className="choose-btn"
              onClick={() => navigate(`/signup?plan=premium&billing=${billing}`)}
            >
              Get Started
            </button>
          </div>
        </section>

        <p className="plans-footnote">*Add more users on either plan for {seatPrice} each.</p>

        <div className="plans-demo-row">
          <button
            type="button"
            className="demo-btn"
            onClick={() => navigate('/demo')}
          >
            Schedule a Demo
          </button>
        </div>

        <section className="plans-compare">
          <div className="compare-row" style={{ fontWeight: 600, color: '#374151' }}>
            <div style={{ textAlign: 'center' }}>Standard</div>
            <div />
            <div style={{ textAlign: 'center' }}>Premium</div>
          </div>
          {getFeatures(seatPrice).map(([label, standard, premium]) => (
            <div key={label} className="compare-row">
              <div className={standard ? 'compare-mark yes' : 'compare-mark no'}>
                {standard ? '✓' : '✕'}
              </div>
              <div className="label">{label}</div>
              <div className={premium ? 'compare-mark yes' : 'compare-mark no'}>
                {premium ? '✓' : '✕'}
              </div>
            </div>
          ))}
        </section>

        <div style={{ textAlign: 'center', marginTop: 48, color: '#6b7280', fontSize: 14 }}>
          Already have an account?{' '}
          <button
            type="button"
            onClick={() => navigate('/')}
            style={{
              background: 'none',
              border: 'none',
              color: '#00a29e',
              fontWeight: 600,
              cursor: 'pointer',
              fontSize: 'inherit',
              padding: 0,
            }}
          >
            Log in
          </button>
        </div>
      </div>
    </div>
  );
}
